import { MatDialog } from '@angular/material/dialog';
import { AbstractStepController, DialogService, FlowStepHandleResult, HandleResultType, StepControl, StepControlType, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class VisitorScanRegistrationQRCodeController extends AbstractStepController {

  private dialogService: DialogService;

  private timer: any;

  private nextControl = new StepControl();

  nextProcessStep: string;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onRegisterToDashboardContext() {
    if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep != null) {
      this.nextProcessStep = this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep;
    }

  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'scanned-visitor-registration-qrcode') {
      try {
        this.forwardToNextStep();
      } catch (e) {
        console.error('invalid qrcode: ' + contextChange.value, e);
      }
    }
  }

  handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('masterdata input started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  getControls(): StepControl[] {

    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
    this.nextControl.type = StepControlType.BUTTON;
    this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.nextControl.controlAction = () => {
      this.forwardToNextStep();
    };
    controls.push(this.nextControl);

    return controls;
  }

  private forwardToNextStep() {
    this.wizardComponent.stopInactivityMonitoring();
    if (this.nextProcessStep != null) {
      this.wizardComponent.next(this.nextProcessStep);
    } else {
      this.wizardComponent.next();
    }
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm  => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.startProcessFlow(this.wizardComponent.contentIdentifier);
      }
    });

  }


}
